<template>
  <el-dialog
    title="Изменение пользователя"
    :visible.sync="$store.getters.userRoleUpdateDialog"
    width="30%"
    :before-close="handleClose"
  >
    <el-form>
      <el-form-item label="Имя">
        <el-input v-model="currentUser.name"> </el-input>
      </el-form-item>
      <el-form-item label="Почта">
        <el-input type="email" v-model="currentUser.email"> </el-input>
      </el-form-item>
      <el-form-item label="Телефон">
        <el-input
          readonly
          @focus="editField"
          @blur="blurField"
          type="tel"
          v-model="currentUser.phone"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="Сделать новый пароль">
        <el-input
          readonly
          @focus="editField"
          @blur="blurField"
          type="password"
          v-model="password"
        />
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="currentUser.activity"></el-checkbox>
      </el-form-item>
      <el-form-item label="Роль">
        <el-radio v-model="currentUser.role" label="admin"
          >Администратор</el-radio
        >
        <el-radio v-model="currentUser.role" label="user"
          >Пользователь</el-radio
        >
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Cancel</el-button>
      <el-button type="primary" @click="(e) => saveUser(e)">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "../../store/mutation-types.js";

export default {
  name: "UpdateRoleUserDialog",
  data: function () {
    return {
      currentUser: [],
      password: "",
    };
  },
  mounted() {
    this.currentUser = this.$store.getters.currentUser;
  },
  methods: {
    handleClose() {
      this.$store.commit("userRoleUpdateDialog", false);
    },
    getTarget(e) {
      const t = e.target;

      return t.classList.contains("el-button") ? t : t.parentNode;
    },
    saveUser(e) {
      const data = {
        role: this.currentUser.role,
        email: this.currentUser.email,
        name: this.currentUser.name,
        password: this.password,
        phone: this.currentUser.phone,
        activity: this.currentUser.activity || false,
      };

      const btn = this.getTarget(e);
      btn.style.pointerEvents = "none";

      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .put("/user/" + this.currentUser.id, data)
        .then(() => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          this.$emit("updateParent3");
          this.$store.commit("userRoleUpdateDialog", false);
          btn.style.pointerEvents = "all";
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    editField(e) {
      const t = e.target;

      t.removeAttribute("readonly");
    },
    blurField(e) {
      const t = e.target;

      t.setAttribute("readonly", "");
    },
  },
};
</script>
